/**
 * Created by stonewang on 2017/8/21.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Radio, Button, Upload, Icon, message, Row, Col, Checkbox, DatePicker} from 'antd';
import {DmsTab, RichEditor, SelectRange} from 'Components';
import {add, detail, modify, getScope} from '../../service/channelFunc';
import {getOrgTree} from '../../service/product';
import {sKeylist} from '../../service/dictionary/dataitem';
import {config} from 'Utils';
import moment from 'moment';
import {showSpin, hideSpin, APIS, openNotice} from 'Utils';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';

//channel_information
class AddFunc extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            infoId: parseInt(this.props.params.id, 10),
            detail: {},
            fileList: [],
            htmlContent: '',
            selectedKeys: [], //抄送范围的ID数组
            selectedNodes: [], //抄送范围的对象数组
            channel_information: [], //类型
            range: '',
            selectOptions: [],
            organizationOptions: [],
            choseType: 'area',
            informationLi: [],
        }
        this.handleOk = this.handleOk.bind(this);
        this.chose = this.chose.bind(this);
        this.openModal = this.openModal.bind(this);
        this.submitHandle = this.submitHandle.bind(this);
    }

    componentWillMount() { //准备数据
        const self = this;
        sKeylist({sKey: 'channel_information'}).then(res => { //类型
            if (res.status) {
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({channel_information: res.data})
                    }
                }, 200);
            }
        })

    }

    componentDidMount() {
        getOrgTree().then(res => {
            if (res.data && res.data.length > 0) {
                for (var i = 0; i < res.data.length; i++) {
                    if (i == 0) {
                        res.data[i].key = 10001;
                    } else {
                        res.data[i].key = res.data[i - 1].key + 1
                    }
                }
                self.setState({selectOptions: res.data});
            }
        });
        getScope().then(res => {
            if (res.data && res.data.length > 0) {
                self.setState({organizationOptions: res.data});
            }
        });
        const self = this;
        this.mounted = true;
        if (this.state.infoId > 0) {
            detail(this.state.infoId).then(res => {
                if (res.status) {
                    const rangeText = res.data.rangeInfoList.map(x => x.name).join(';');
                    self.setState({
                        detail: {...res.data, rangeText},
                        selectedKeys: res.data.rangeList.map(x => x.toString()),
                        selectedNodes: res.data.rangeInfoList,
                        htmlContent: res.data.content,
                        fileList: [
                            {
                                uid: -1,
                                name: '',
                                status: 'done',
                                id: res.data.picId,
                                url: res.data.filePath ? `${config.server}${res.data.filePath}` : '',
                                thumbUrl: res.data.filePath ? `${config.server}${res.data.filePath}` : ''
                            }
                        ],
                        informationLi: [
                            {
                                uid: -2,
                                name: res.data.enclosureName,
                                status: 'done',
                                id: res.data.enclosureId,
                                url: res.data.enclosureId ? `${config.server}${res.data.enclosurePath.replace("getFile", "getFileDown")}` : '',
                                // thumbUrl: res.data.filePath ? `${config.server}${res.data.filePath}` : ''
                            }
                        ],
                    });
                }
            });
        }

    }

    cancelHandle() {
        hashHistory.goBack()
    }

    submitHandle() {
        const {fileList, infoId, selectedKeys, selectedNodes} = this.state;
        const {validateFields, getFieldsValue} = this.props.form;

        validateFields((errors) => {//表单校验
            if (errors) {
                return
            }//表单校验有误，则不执行下面的代码
            const data = {
                ...getFieldsValue() //获取用户输入
            };
            data.rangeList = selectedKeys;
            data.rangeInfoList = selectedNodes;
            if (fileList.length > 0) {
                data.picId = fileList[0]['id'];
            } else {
                message.error('请设置列表展示图片');
                return null;
            }
            showSpin();
            let informationLi = this.state.informationLi || [];

            let enclosureId = '';
            for (var i = 0; i < informationLi.length; i++) {
                // console.log(informationLi[i]);
                enclosureId = enclosureId + informationLi[i].id + ',';
            }
            data.enclosureId = enclosureId.substr(0, enclosureId.length - 1);
            if (data.enclosureId && data.enclosureId != '') {
                data.enclosuretype = 'picture';
            }
            if (data.rangeList.length == 0 || data.rangeList == []) {
                openNotice('warning', '请确认发布范围');
                return
            }
            if (infoId > 0) {
                modify({...data, id: infoId}).then(res => {
                    hideSpin();
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && hashHistory.goBack()
                })
            } else {
                add({...data}).then(res => {
                    hideSpin();
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && hashHistory.goBack()
                })
            }
        })
    }

    chose = (type) => {
        this.setState({
            choseType: type
        });
    };
    //发布范围相关
    handleOk = (keys, nodes) => {
        const rangeText = nodes.map(x => x.name).join(';');
        this.setState({
            visible: false,
            detail: {...this.state.detail, rangeText},
            selectedKeys: keys,
            selectedNodes: nodes,
        })
    }

    openModal() {
        this.selectRangModal.showModal();
    }

    checkboxOnChange = (e) => {
        e.stopPropagation();
        const {detail} = this.state;
        this.setState({
            detail: {...detail, zhiding: e.target.checked}
        });
    };

    rangeChange = (e) => {
        this.setState({
            range: e.target.value,
        });
    }
    // /*上传附件*/
    // updateInformation(result) {
    //         let informationLi = this.state.informationLi || [];
    //         if (result.file.status === 'done') {
    //             let responseData = result.file.response || {};
    //             if (responseData.code != 200) {
    //                 openNotice('error', '附件上传失败');
    //                 return;
    //             }
    //             // informationLi= [{
    //             //     id: responseData.data.id,
    //             //     fileName: responseData.data.fileName,
    //             //     url : `${config.server}${responseData.data.filePath.split('?')[0]}?id=${responseData.data.id}`,
    //             // }]
    //             // informationLi = informationLi.slice(-1);
    //             // return informationLi;
    //             // return file;
    //             // informationLi = informationLi.filter((file) => {
    //             //   if (file.response) {
    //             //     return file.response.status; //当上传接口返回成功时才更新fileList
    //             //   }
    //             //   return true;
    //             // });
    //         }
    //         this.setState({
    //             informationLi: informationLi
    //         },()=>{
    //           console.log(this.state.informationLi)
    //         })
    //  }
    /*产品资料*/
    updateInformation(result) {
        let informationLi = this.state.informationLi || [];
        if (result.file.status === 'done') {
            let responseData = result.file.response || {};
            if (responseData.code != 200) {
                openNotice('error', '附件上传失败');
                return;
            }
            informationLi = [{
                id: responseData.data.id,
                fileName: responseData.data.fileName,
            }];
        }
        this.setState({
            informationLi: informationLi
        })
    };

    deleteInformation(index) {
        /* 删除产品资料 */
        const {informationLi} = this.state;
        informationLi.splice(index, 1);
        this.setState({
            informationLi: informationLi
        });
    };

    render() {
        var self = this;
        const {
            informationLi,
            detail,
            fileList,
            channel_information,
            selectedKeys,
            selectedNodes,
            htmlContent,
            selectOptions,
            organizationOptions,
            choseType
        } = this.state;
        const {getFieldDecorator} = this.props.form;
        console.log(informationLi);
        let informationHtml = (informationLi || []).map(function (ele, key) {
            return <div className="edit_upload_information" key={key}>
                <span>{ele.fileName}</span>
                <i className="anticon anticon-delete" onClick={self.deleteInformation.bind(self, key)}></i>
            </div>
        });
        const informationProps = {
            fileList: [...informationLi],
            className: 'upload-img-only',
            listType: 'file',
            action: APIS.upload,
            // uid: -2,
            // headers: {
            //     authorization: 'authorization-text',
            // },
            // onChange: this.updateInformation.bind(this),
            onChange: (info) => {
                console.log(info);
                let fileList = info.fileList;
                fileList = fileList.slice(-1); //控制上传数量
                fileList = fileList.map((file) => {
                    if (file.response) {//上传成功后提取文件id 和 URL
                        file.url = `${config.server}${file.response.data.filePath.replace("getFile", "getFileDown")}`;
                        file.id = file.response.data.id;
                    }
                    return file;
                });
                fileList = fileList.filter((file) => {
                    if (file.response) {
                        return file.response.status; //当上传接口返回成功时才更新fileList
                    }
                    return true;
                });

                this.setState({informationLi: fileList});
            }
            // showUploadList: false,
            // defaultFileList: [],
            // data: {
            //   id: '10000',
            //   type : '-10000',
            // }
        };
        const abbProps = {
            action: `${config.server}/api/v1/dms/commonAttachUpload/mongoUpload`,
            listType: 'picture',
            //defaultFileList: [...fileList],
            fileList: [...fileList], //受控模式不使用defaultFileList初始化，改用fileList
            className: 'upload-img-only',
            onChange: (info) => {
                let fileList = info.fileList;
                fileList = fileList.slice(-1); //控制上传数量
                fileList = fileList.map((file) => {
                    if (file.response) {//上传成功后提取文件id 和 URL
                        file.url = `${config.server}${file.response.data.filePath.replace("getFile", "getFileDown")}`;
                        file.id = file.response.data.id;
                    }
                    return file;
                });
                fileList = fileList.filter((file) => {
                    if (file.response) {
                        return file.response.status; //当上传接口返回成功时才更新fileList
                    }
                    return true;
                });

                this.setState({fileList}); //在该处理方法的结束位置必须执行此行代码，这是用来解决onChange只调用一次的问题
            }
        };
        return <div className="dms-body">
            <DmsTab options={['新建发布']} defaultKey={0}>
                <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
            </DmsTab>
            <div className="dms-table-box">
                <div className="upload_add_pro" style={{marginBottom: '12px'}}>
                    <Upload {...abbProps}>
                        <span className="ti">列表展示图<font>*</font></span>
                        <Button>选择图片文件</Button>
                        <span className="hint">建议图片大小 : 520x420px</span>
                    </Upload>
                </div>
                <Form layout="horizontal">
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="标题：" hasFeedback>
                                {getFieldDecorator('title', {
                                    initialValue: detail.title || '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '标题不合法',
                                            min: 1,
                                            max: 30
                                        }
                                    ],
                                })(<Input placeholder="请输入标题"/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="发布范围：">
                                {getFieldDecorator('rangeType', {
                                    initialValue: detail.rangeType !== '' ? detail.rangeType + '' : '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择发布范围'
                                        }
                                    ],
                                })(<RadioGroup onChange={this.rangeChange}>
                                    {/*<Radio value="1">天正内部</Radio>*/}
                                    <Radio value="0">客户</Radio>
                                </RadioGroup>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="发布范围：">
                                <Input placeholder="请选择发布范围" value={detail.rangeText} onClick={this.openModal}/>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="首页头条：">
                                {getFieldDecorator('zhiding', {
                                    onChange: this.checkboxOnChange
                                })(<Checkbox checked={detail.zhiding}>首页头条</Checkbox>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="发布日期：">
                                {getFieldDecorator('pubDate', {
                                    initialValue: moment(new Date(), dateFormat),
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择'
                                        },
                                    ]
                                })(<DatePicker format={dateFormat}/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="评论权限：" hasFeedback>
                                {getFieldDecorator('isComment', {
                                    initialValue: detail.isComment !== '' ? detail.isComment + '' : '',
                                    rules: [
                                        {
                                            required: true,
                                        },
                                    ]
                                })(
                                    <RadioGroup>
                                        <Radio value="1">可评论</Radio>
                                        <Radio value="0">不可评论</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="分类：" hasFeedback>
                                {getFieldDecorator('type', {
                                    initialValue: detail.type ? detail.type + '' : '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择分类'
                                        },
                                    ]
                                })(
                                    <Select
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择分类"
                                    >
                                        {
                                            channel_information.map((item, key) => {
                                                return <Select.Option key={key + ''}
                                                                      value={item.sKey}>{item.name}</Select.Option>
                                            })
                                        }
                                    </Select>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <FormItem label="正文：" hasFeedback>
                            {getFieldDecorator('content', {
                                initialValue: htmlContent || '',
                                valuePropName: 'htmlContent',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正文'
                                    },
                                ],
                            })(<RichEditor/>)}
                        </FormItem>
                    </Row>
                </Form>
                <Upload {...informationProps}>
                    <div style={{padding: '12px', background: '#fff'}}>
                        <Button><Icon type="upload"/> 上传扫描件</Button>
                    </div>
                </Upload>
            </div>
            <SelectRange ref={(node) => {
                this.selectRangModal = node;
            }}
                         keys={selectedKeys}
                         nodes={selectedNodes}
                         options={choseType === 'area' ? selectOptions : organizationOptions}
                         checked={false}
                         chose={this.chose}
                         onOk={this.handleOk}/>
        </div>
    }
}

export default Form.create()(AddFunc)


// WEBPACK FOOTER //
// ./src/routes/channelFunc/add.js